import React, { useState, useEffect } from 'react';
import { Input, Label, CloseButton } from "reactstrap";
import useApi from "../../hooks/useApi";

function MaterialChoose({ isRemovable, projectTypeId, onProjectMaterialChange, projectMaterials, apiToken }) {
    const [selectedMaterial, setSelectedMaterial] = useState(null);
    const [selectedMaterialPriceListType, setSelectedMaterialPriceListType] = useState(null);
    const [selectedMaterialPriceListTypeValue, setSelectedMaterialPriceListTypeValue] = useState('');
    const [selectedMaterialPrice, setSelectedMaterialPrice] = useState(null);
    const [materialQuantity, setMaterialQuantity] = useState('');
    const [materialTotal, setMaterialTotal] = useState(0);
    const [componentEnabled, setComponentEnabled] = useState(true);
    const [materialQualities, setMaterialQualities] = useState([]);
    const materialApi = useApi('material/GetMaterialsByProjectType');
    const materialPriceListApi = useApi('material/GetMaterialPriceListByMaterial');

    useEffect(() => {
        populateMaterials();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectTypeId]);

    useEffect(() => {
        if (materialPriceListApi.data) {
            let listTypes = [];
            materialPriceListApi.data.forEach(function (priceList) {
                listTypes.push(priceList.materialCategory);
            });
            setMaterialQualities(materialPriceListApi.data);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [materialPriceListApi.data]);

    const populateMaterials = async () => {
        if (projectTypeId) {
            const requestParams = {
                projectTypeId: projectTypeId,
                ...projectMaterials.length && {
                    excludeMaterialId: Object.keys(projectMaterials).map(
                        (key) => {return projectMaterials[key].id}
                    )
                }
            };

            materialApi.get(
                requestParams,
                apiToken
            );
        }
    }

    const populateMaterialPriceList = async (materialId) => {
        if (materialId) {
            materialPriceListApi.get({materialId: materialId});
        }
    }

    const handleMaterialChange = (e) => {
        let selectedOption = e.target.options[e.target.selectedIndex];
        let selectedMaterialId = parseInt(selectedOption.value);
        let chosenMaterial = materialApi.data?.find(material => material.id === selectedMaterialId);
        if (chosenMaterial) {
            setSelectedMaterial(chosenMaterial);
            populateMaterialPriceList(selectedMaterialId);
            if (selectedMaterialPriceListTypeValue !== '') {
                setSelectedMaterialPriceListType(null);
                setSelectedMaterialPriceListTypeValue('');
                setMaterialQuantity('');
            }
        }
    }

    const handleMaterialPriceListTypeChange = (e) => {
        let selectedOption = e.target.options[e.target.selectedIndex];
        let priceInList = materialQualities.filter(
            materialPriceListType => materialPriceListType.id === parseInt(e.target.value)
            );
        setSelectedMaterialPriceListTypeValue(e.target.value);
        setSelectedMaterialPriceListType(selectedOption.text);
        let materialPrice = 0;
        if (priceInList[0] !== undefined) {
            materialPrice = priceInList[0].price;
            setSelectedMaterialPrice(materialPrice);
        }
        updateMaterialTotal(materialPrice, materialQuantity);
        if (typeof onProjectMaterialChange === 'function') {
            onProjectMaterialChange(buildProjectMaterial(selectedMaterial, materialQuantity, materialPrice));
        }
    }

    const handleMaterialQuantityChange = (e) => {
        setMaterialQuantity(e.target.value);
        if (selectedMaterialPrice) {
            const price = parseFloat(selectedMaterialPrice);
            const quantity = parseFloat(e.target.value);

            if (!isNaN(price) && !isNaN(quantity)) {
                let totalBudget = price * quantity;
                setMaterialTotal(totalBudget);
            } else {
                setMaterialTotal(0);
            }

            if (typeof onProjectMaterialChange === 'function') {
                onProjectMaterialChange(buildProjectMaterial(selectedMaterial, quantity));
            }
        }
    }

    const handleComponentDisable = () => {
        if (selectedMaterial) {
            setSelectedMaterialPriceListType(null);
            setSelectedMaterialPriceListTypeValue('');
            setMaterialQuantity('');
            if (typeof onProjectMaterialChange === 'function') {
                onProjectMaterialChange(buildProjectMaterial(selectedMaterial, 0));
            }
        }
        setComponentEnabled(false);
    }

    const updateMaterialTotal = (price, quantity) => {
        if (!isNaN(price) && !isNaN(quantity)) {
            let totalBudget = price * quantity;
            setMaterialTotal(totalBudget);
        } else {
            setMaterialTotal(0);
        }
    }

    const buildProjectMaterial = (selectedMaterial, quantity, priceParam) => {
        let builtSelectedMaterial = {
            ...selectedMaterial,
            materialCategory: {}
        };

        let categoryInList = materialQualities.filter(
            materialCategory => materialCategory.id === parseInt(selectedMaterialPriceListTypeValue)
        );
        
        if (categoryInList[0] !== undefined) {
            builtSelectedMaterial.materialCategory = categoryInList[0].materialCategory;
        }
console.log(builtSelectedMaterial);
        const materialPrice = isNaN(priceParam) ? selectedMaterialPrice : priceParam;
        const price = parseFloat(materialPrice);
        const qty = quantity !== undefined ? quantity : parseFloat(materialQuantity);
        return {
            id: builtSelectedMaterial.id,
            quantity: qty,
            price: price,
            materialBudget: price * qty,
            material: builtSelectedMaterial
        }        
    }

    const materialOptions = materialApi.data ? materialApi.data.map(
        (material) => <option key={material.id} value={material.id}>{material.name}</option>
    ) : [];

    var materialPriceListTypeOptions = materialPriceListApi.data ? materialPriceListApi.data.map(
        (materialPriceListType) => <option
            key={materialPriceListType.id}
            value={materialPriceListType.id}>{materialPriceListType.materialCategory.description}</option>
    ) : [];

    const materialMeasurementUnit = selectedMaterial && selectedMaterial.measurementUnit !== null
        ? selectedMaterial.measurementUnit.shortDescription
        : 'Unit';

    const priceLabelValue = selectedMaterialPriceListType !== null && selectedMaterialPrice !== null
        ? selectedMaterialPriceListType + " Price Usd "
        + selectedMaterialPrice
        + " / " + materialMeasurementUnit
        : ""; 

    return (
        <div className={componentEnabled ? "row" : "visually-hidden" }>
            <div className="col-sm">
                <Input type="select" defaultValue="" onChange={handleMaterialChange} disabled={!projectTypeId}>
                    <option value="" disabled hidden>
                        {materialApi.loading
                            ? "Loading..."
                            : materialOptions.length
                                ? "Choose a material..."
                                : "No materials found"}
                    </option>
                    {materialOptions}
                </Input>
                <div className={!selectedMaterial ? "visually-hidden" : ""}>
                    <Input
                        type="textarea"
                        className="bg-white"
                        value={selectedMaterial ? selectedMaterial.description : ''}
                        readOnly
                    />
                </div>
            </div>
            <div className="col-sm">
                <Input type="select"
                    value={selectedMaterialPriceListTypeValue}
                    onChange={handleMaterialPriceListTypeChange}
                    disabled={materialPriceListTypeOptions.length === 0}>
                    <option value="" disabled hidden>
                        {materialPriceListTypeOptions.length === 0
                            ? ""
                            : "Choose the quality..."}
                    </option>
                    {materialPriceListTypeOptions}
                </Input>
            </div>
            <div className="col-sm">
                <div className="row">
                    <div className="col-sm-3 mt-auto">
                        <Label>Quantity</Label>
                    </div>
                    <div className="col-sm">
                        <Input type="number"
                            value={materialQuantity}
                            className="text-end"
                            onChange={handleMaterialQuantityChange}
                            disabled={selectedMaterialPriceListType === null}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-3"></div>
                    <div className="col-sm">
                        <Label>{priceLabelValue}</Label>
                    </div>
                </div>
            </div>
            <div className="col-sm">
                <div className="col-sm text-end">
                    <Input type="number"
                        value={materialTotal}
                        disabled={selectedMaterialPriceListType === null}
                        className="text-end"
                    />
                    <Label>Total Usd</Label>
                </div>
            </div>
            <div className={isRemovable ? "col-sm-1 text-center" : "visually-hidden" } >
                <CloseButton onClick={handleComponentDisable} />
            </div>
        </div>
    );
}

export default MaterialChoose;